import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

export interface EncryptionInfoDialogProps {
  open: boolean;
  onClose: () => void;
  /** Present for the study owner only: opens the per-conversation reset confirmation. */
  onResetChat?: () => void;
}

/** The "Encryption" sheet: one sentence, Close, and (owner only) Reset chat. */
export function EncryptionInfoDialog({ open, onClose, onResetChat }: EncryptionInfoDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth className="ph-no-capture" PaperProps={{ className: 'ph-no-capture' }} aria-labelledby="encryption-info-title">
      <DialogTitle id="encryption-info-title" sx={{ fontWeight: 600 }}>
        Encryption
      </DialogTitle>
      <DialogContent sx={{ pt: '8px !important' }}>
        <DialogContentText>Messages are encrypted end to end.</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {onResetChat && (
          <Button color="error" onClick={onResetChat} sx={{ mr: 'auto', textTransform: 'none' }}>
            Reset chat
          </Button>
        )}
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
